import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-help-related-exposure-drafts',
  templateUrl: './help-related-exposure-drafts.component.html'
 
})
export class HelpRelatedExposureDraftsComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
   ) { }
  rfd_header;
  rfd_body;
  content_initialized: boolean = false;
  ngOnInit(): void {
   
    this.commonDataService.showLoader.next(true);
    this.getRelatedExposuredrafts();
  }
  getRelatedExposuredrafts() {


    this.graphQlService.getRelatedExposureDrafts().subscribe(data => {
      if (data != "") {

        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.rfd_header = labels.filter(x => x.key == "rfd_header").map(y => y.value);
        this.rfd_body = labels.filter(x => x.key == "rfd_body").map(y => y.value);      
        this.content_initialized = true;

        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

}
